import React, {useState, useRef, useEffect} from "react"
import {autoResize, eyeHandler, getLocalStorageItem} from "../functions"
import $ from "jquery"
import {Link} from "react-router-dom"

export default function LinkPropertiesCard({data, lang}) {
    const [copied, setCopied] = useState(false)
    const properties = getLocalStorageItem('link-properties-data')

    // Редактирование полей
    const [isEditingLink, setIsEditingLink] = useState(false)
    const [isEditingName, setIsEditingName] = useState(false)
    const [isEditingLogin, setIsEditingLogin] = useState(false)
    const [isEditingPassword, setIsEditingPassword] = useState(false)
    const [isEditingDesc, setIsEditingDesc] = useState(false)

    const [linkValue, setLinkValue] = useState(data.link.from)
    const [nameValue, setNameValue] = useState(data.link.name)
    const [loginValue, setLoginValue] = useState(data.link.login || '')
    const [descValue, setDescValue] = useState(data.link.description || '')
    const [passwordValue, setPasswordValue] = useState(data.link.password || '')

    const linkInputRef = useRef(null)
    const nameInputRef = useRef(null)
    const loginInputRef = useRef(null)
    const descTextareaRef = useRef(null)
    const passwordInputRef = useRef(null)

    const formatDate = (date) => date ? new Date(date).toLocaleString() : '—'
    const borderThumb = data.fileType === 'google-file' ? 'solid 2px gray' : ''

    useEffect(() => {
        autoResize(descTextareaRef.current)
        if (properties.from !== linkValue ||
            properties.name !== nameValue ||
            properties.desc !== descValue ||
            properties.login !== loginValue ||
            properties.pass !== passwordValue) {
            document.querySelector('#btn-save').removeAttribute('disabled')
        }
    }, [linkValue, descValue, nameValue, loginValue, passwordValue, properties])

    let linkSmall = new URL(data.link.from).host + new URL(data.link.from).pathname, flag = false
    if (linkSmall.includes('www')) {
        linkSmall = linkSmall.split('www.')[1]
    }

    if (data.thumb && data.thumb.includes("link-logo-default")) {
        flag = true
    }

    return (
        <div style={{padding: 20}}>

            {data.thumb && (
                <Link to={linkValue} rel={"noreferrer noopener"} target={'_blank'}>
                    <div className={'link-prop-card-thumb'}>
                        <img className={'link-prop-card-thumb-img'}
                             src={data.thumb}
                             alt="thumbnail"
                             style={{border: borderThumb}}
                        />
                    </div>
                    {flag && <p id={'p-link-from'}
                        style={{
                            position: 'absolute',
                            left: '42%',
                            top: 92,
                            width: 80,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            color: 'black'
                        }}>
                        <span id={'link-from'}>{linkSmall}</span>
                    </p>}
                </Link>
            )}

            <div className={'folder-prop-card'}>

                {/* ДАТА СОЗДАНИЯ */}
                <div className={'link-prop-card-row'}>
                    <div className={'link-prop-card-row-inner'}>
                        <span className={'link-prop-card-label'}>
                            {lang.body.linkPage.createdDate}
                        </span>
                        <span>{formatDate(data.link.dateCreated)}</span>
                    </div>
                </div>

                {/* ВЛАДЕЛЕЦ */}
                <div className={'link-prop-card-row'}>
                    <div className={'link-prop-card-row-inner'}>
                        <span className={'link-prop-card-label'}>Владелец ссылки</span>
                        <span>{data.owner.name}</span>
                    </div>
                </div>

                {/* НАЗВАНИЕ */}
                <div className={'link-prop-card-row'}>
                    <div className={'link-prop-card-row-inner'}>
                        <span className={'link-prop-card-label'}>{lang.body.linkPage.labelSiteTitle}</span>
                        <div className={'link-prop-card-input-container'}>
                            <input id={'name'}
                                   ref={nameInputRef}
                                   value={nameValue}
                                   readOnly={!isEditingName}
                                   className={'link-prop-card-input-inner'}
                                   onChange={(e) => setNameValue(e.target.value)}
                            />
                            <div className={'link-prop-card-btn'} onClick={() => {
                                if (!isEditingName) {
                                    setIsEditingName(true)
                                    setTimeout(() => nameInputRef.current?.focus(), 0)
                                } else {
                                    setIsEditingName(false)
                                }
                            }}>
                                <i className={isEditingName ? "fa-solid fa-check" : "fa-solid fa-pen"}/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ОПИСАНИЕ */}
                <div className={'link-prop-card-row'}>
                    <div className={'link-prop-card-row-inner'}>
                        <span className={'link-prop-card-label'}>{lang.body.linkPage.labelSiteDescription}</span>
                        <div className={'link-prop-card-input-container'}>
                            <textarea id={'description'}
                                      ref={descTextareaRef}
                                      value={descValue}
                                      readOnly={!isEditingDesc}
                                      rows={1}
                                      className={'link-prop-card-input-inner'}
                                      onChange={(e) => setDescValue(e.target.value)}
                                      onInput={() => autoResize(descTextareaRef.current)}
                                      style={{resize: 'none', overflow: 'hidden', height: '32px', lineHeight: '16px'}}
                            />
                            <div className={'link-prop-card-btn'} onClick={() => {
                                if (!isEditingDesc) {
                                    setIsEditingDesc(true)
                                    setTimeout(() => {
                                        autoResize(descTextareaRef.current)
                                        descTextareaRef.current?.focus()
                                    }, 0)
                                } else {
                                    setIsEditingDesc(false)
                                }
                            }}>
                                <i className={isEditingDesc ? "fa-solid fa-check" : "fa-solid fa-pen"}/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ЛОГИН */}
                <div className={'link-prop-card-row'}>
                    <div className={'link-prop-card-row-inner'}>
                        <span className={'link-prop-card-label'}>{lang.body.linkPage.labelLoginSite}</span>
                        <div className={'link-prop-card-input-container'}>
                            <input id={'login'}
                                   ref={loginInputRef}
                                   value={loginValue}
                                   readOnly={!isEditingLogin}
                                   className={'link-prop-card-input-inner'}
                                   onChange={(e) => setLoginValue(e.target.value)}
                            />
                            <div className={'link-prop-card-btn'} onClick={() => {
                                if (!isEditingLogin) {
                                    setIsEditingLogin(true)
                                    setTimeout(() => loginInputRef.current?.focus(), 0)
                                } else {
                                    setIsEditingLogin(false)
                                }
                            }}>
                                <i className={isEditingLogin ? "fa-solid fa-check" : "fa-solid fa-pen"}/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ПАРОЛЬ */}
                <div className={'link-prop-card-row'}>
                    <div className={'link-prop-card-row-inner'}>
                        <span className={'link-prop-card-label'}>{lang.body.linkPage.labelPasswordSite}</span>
                        <div className={'link-prop-card-input-container'}>
                            {/* глазик слева */}
                            <div className={'link-prop-card-eye-left'}
                                 onClick={() => eyeHandler($('#eye-pass'), $('#password'))}>
                                <i id="eye-pass" className="fa-regular fa-eye-slash"/>
                            </div>

                            <input id={'password'}
                                   ref={passwordInputRef}
                                   type={isEditingPassword ? "text" : "password"}
                                   value={passwordValue}
                                   readOnly={!isEditingPassword}
                                   className={'link-prop-card-input-inner'}
                                   onChange={(e) => setPasswordValue(e.target.value)}
                            />

                            <div className={'link-prop-card-btn'} onClick={() => {
                                if (!isEditingPassword) {
                                    setIsEditingPassword(true)
                                    setTimeout(() => passwordInputRef.current?.focus(), 0)
                                } else {
                                    setIsEditingPassword(false)
                                }
                            }}>
                                <i className={isEditingPassword ? "fa-solid fa-check" : "fa-solid fa-pen"}/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ССЫЛКА */}
                <div className={'link-prop-card-row'}>
                    <div className={'link-prop-card-row-inner'}>
                        <span className={'link-prop-card-label'}>
                            {lang.body.linkPage.labelSiteLink}
                        </span>

                        <div className={'link-prop-card-input-container'}>
                            {!isEditingLink ? (
                                <input
                                    id={'from'}
                                    ref={linkInputRef}
                                    value={linkValue}
                                    readOnly
                                    className={'link-prop-card-input-link-inner'}
                                    onClick={() => {
                                        setIsEditingLink(true)
                                        setTimeout(() => {
                                            autoResize(linkInputRef.current)
                                            linkInputRef.current?.focus()
                                        }, 0)
                                    }}
                                />
                            ) : (
                                <textarea
                                    id={'from'}
                                    ref={linkInputRef}
                                    value={linkValue}
                                    rows={1}
                                    className={'link-prop-card-input-inner'}
                                    onChange={(e) => setLinkValue(e.target.value)}
                                    onInput={() => autoResize(linkInputRef.current)}
                                    style={{
                                        resize: 'none',
                                        overflow: 'hidden',
                                        lineHeight: '16px'
                                    }}
                                    onBlur={() => {
                                        setIsEditingLink(false)
                                    }}
                                />
                            )}

                            <div
                                className={'link-prop-card-btn'}
                                onClick={async () => {
                                    await navigator.clipboard.writeText(String(linkValue))
                                    setCopied(true)
                                    setTimeout(() => setCopied(false), 2000)
                                }}>
                                <i className={'fa-regular fa-copy'}/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* Тост снизу */}
            {copied && (
                <div className={'folder-prop-card-shared-link-toast'} style={{
                    position: 'fixed',
                    bottom: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 9999
                }}>
                    {lang.body.folderPage.linkCopied}
                </div>
            )}
        </div>
    )
}